import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import s from './preview.scss';
export const LocalVideoPreview = ({ dataHook, video, selectedCamera, screenShare, onDeniedScreenShare, dashboard, }) => {
    const videoRef = useRef(null);
    useEffect(() => {
        setStream();
        return stopTracks;
    }, [video, selectedCamera, screenShare]);
    const stopTracks = () => {
        var _a;
        const srcObject = (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.srcObject;
        return srcObject === null || srcObject === void 0 ? void 0 : srcObject.getTracks().forEach(track => track.stop());
    };
    const setStream = async () => {
        stopTracks();
        if (screenShare) {
            try {
                videoRef.current.srcObject = await navigator.mediaDevices.getDisplayMedia();
                videoRef.current.srcObject.getVideoTracks()[0].onended = () => {
                    onDeniedScreenShare();
                };
            }
            catch (e) {
                onDeniedScreenShare();
            }
            return;
        }
        if (video) {
            const constraints = dashboard ? { facingMode: 'environment', aspectRatio: { exact: 1.7777777778 }, width: 9999 } : {};
            videoRef.current.srcObject = await navigator.mediaDevices.getUserMedia({
                video: video ? Object.assign({ deviceId: selectedCamera }, constraints) : false,
                audio: false,
            });
            await videoRef.current.play();
        }
        else {
            videoRef.current.srcObject = null;
        }
    };
    return (React.createElement("video", { "data-hook": dataHook, playsInline: true, muted: true, className: classNames(s.container, { [s.screenShare]: screenShare }), ref: videoRef, autoPlay: true }));
};
//# sourceMappingURL=preview.js.map